import React, { Component } from "react";

const styles = {
  document: {
    color: "#000000",
    fontFamily: "sans-serif",
    fontSize: "9pt",
  },
  header: {
    marginBottom: "12pt",
    textAlign: "center",
  },
  title: {
    fontSize: "18pt",
    margin: "0 0 6pt",
  },
  headerLine: {
    margin: "3pt 0",
  },
  balanceTable: {
    borderCollapse: "collapse",
    fontSize: "8pt",
    width: "100%",
  },
  totalTable: {
    borderCollapse: "collapse",
    fontSize: "8pt",
    marginTop: "4pt",
    width: "100%",
  },
  columnHeader: {
    backgroundColor: "#e6e6e6",
    border: "1px solid #000000",
    padding: "3pt",
    textAlign: "center",
    verticalAlign: "middle",
  },
  cell: {
    border: "1px solid #000000",
    padding: "3pt",
    verticalAlign: "top",
  },
  centerCell: {
    border: "1px solid #000000",
    padding: "3pt",
    textAlign: "center",
    verticalAlign: "top",
  },
  amountCell: {
    border: "1px solid #000000",
    padding: "3pt",
    textAlign: "right",
    verticalAlign: "top",
    whiteSpace: "nowrap",
  },
  totalLabelCell: {
    backgroundColor: "#f2f2f2",
    border: "1px solid #000000",
    padding: "3pt",
    textAlign: "right",
    verticalAlign: "top",
  },
  totalAmountCell: {
    backgroundColor: "#f2f2f2",
    border: "1px solid #000000",
    padding: "3pt",
    textAlign: "right",
    verticalAlign: "top",
    whiteSpace: "nowrap",
  },
};

export default class BalancePDF extends Component {
  render() {
    const {
      balanceComptes,
      dateDu,
      dateAu,
      compteCentralisateur,
      compteDu,
      compteAu,
      comptes,
      tri,
    } = this.props;

    if (tri === 2) {
      balanceComptes.sort((a, b) => a.compte_libelle.localeCompare(b.compte_libelle));
    } else {
      if (compteCentralisateur) {
        balanceComptes.sort((a, b) => a.compte_auxiliaire - b.compte_auxiliaire);
      } else {
        balanceComptes.sort((a, b) => a.compte_general - b.compte_general);
      }
    }

    let totalDebit = 0;
    let totalCredit = 0;
    let totalSoldeDebit = 0;
    let totalSoldeCredit = 0;
    balanceComptes.forEach((ligne, i) => {
      totalDebit += parseFloat(ligne.total_debit);
      totalCredit += parseFloat(ligne.total_credit);
      // Chaque colonne de solde totalise ses propres soldes (comme le TOTAL de l'écran)
      totalSoldeDebit += parseFloat(ligne.total_solde_debit);
      totalSoldeCredit += parseFloat(ligne.total_solde_credit);
    });

    const lignesEcrituresFiltered = balanceComptes;

    // 0,00 € affiché seulement sur un compte soldé, case vide sinon (comme à l'écran)
    const renderMontant = (montant, ligne) =>
      parseFloat(montant) !== 0 ||
      (ligne.total_solde_debit === 0 && ligne.total_solde_credit === 0) ? (
        parseFloat(montant).toLocaleString("fr-FR", { style: "currency", currency: "EUR" })
      ) : (
        <></>
      );

    return (
      <div style={styles.document}>
        {/* Titre */}
        <div style={styles.header}>
          <h1 style={styles.title}>
            {compteCentralisateur ? (
              <>{`Balance Auxiliaire ${
                comptes.find((compte) => compte.compte_id === compteCentralisateur)
                  .compte_compte_general
              } - ${
                comptes.find((compte) => compte.compte_id === compteCentralisateur).compte_libelle
              }`}</>
            ) : (
              <>{`Balance Générale`}</>
            )}
          </h1>
          <p style={styles.headerLine}>
            <span>
              <strong>
                {`Situation ${
                  dateDu ? "du " + dateDu.format("DD/MM/YYYY") + " " : ""
                }au ${dateAu.format("DD/MM/YYYY")}`}
              </strong>
            </span>
          </p>
          <p style={styles.headerLine}>
            {compteCentralisateur ? (
              <strong>
                {`Compte du ${
                  comptes.find((compte) => compte.compte_compte_auxiliaire === compteDu)
                    .compte_compte_auxiliaire
                } - ${
                  comptes.find((compte) => compte.compte_compte_auxiliaire === compteDu)
                    .compte_libelle
                } au ${
                  comptes.find((compte) => compte.compte_compte_auxiliaire === compteAu)
                    .compte_compte_auxiliaire
                } - ${
                  comptes.find((compte) => compte.compte_compte_auxiliaire === compteAu)
                    .compte_libelle
                }`}
              </strong>
            ) : (
              <strong>
                {`Compte du ${
                  comptes.find(
                    (compte) =>
                      compte.compte_compte_general === compteDu && compte.compte_type_compte !== "A"
                  ).compte_compte_general
                } - ${
                  comptes.find(
                    (compte) =>
                      compte.compte_compte_general === compteDu && compte.compte_type_compte !== "A"
                  ).compte_libelle
                } au ${
                  comptes.find(
                    (compte) =>
                      compte.compte_compte_general === compteAu && compte.compte_type_compte !== "A"
                  ).compte_compte_general
                } - ${
                  comptes.find(
                    (compte) =>
                      compte.compte_compte_general === compteAu && compte.compte_type_compte !== "A"
                  ).compte_libelle
                }`}
              </strong>
            )}
          </p>
        </div>

        <div>
          <table style={styles.balanceTable}>
            <thead>
              <tr>
                <th colSpan="5" width="70%" style={styles.columnHeader}></th>
                <th colSpan="2" width="30%" style={styles.columnHeader}>
                  <strong>SOLDE</strong>
                </th>
              </tr>
              <tr>
                <th colSpan="2" width="14%" scope="col" style={styles.columnHeader}>
                  <strong>COMPTE</strong>
                </th>

                <th width="26%" scope="col" style={styles.columnHeader}>
                  <strong> LIBELLE</strong>
                </th>
                <th width="15%" scope="col" style={styles.columnHeader}>
                  <strong>DEBIT </strong>
                </th>
                <th width="15%" scope="col" style={styles.columnHeader}>
                  <strong>CREDIT </strong>
                </th>
                <th width="15%" scope="col" style={styles.columnHeader}>
                  <strong>DEBIT</strong>
                </th>
                <th width="15%" scope="col" style={styles.columnHeader}>
                  <strong>CREDIT</strong>
                </th>
              </tr>
            </thead>
            <tbody>
              {lignesEcrituresFiltered.map((ligneF, i) => (
                <tr
                  key={i}
                  style={{ backgroundColor: i % 2 === 0 ? "#ffffff" : "#eeeeee" }}
                >
                  <td width="7%" style={styles.centerCell}>
                    {ligneF.compte_general}
                  </td>
                  <td width="7%" style={styles.centerCell}>
                    {ligneF.compte_auxiliaire}
                  </td>
                  <td width="26%" style={styles.cell}>
                    {ligneF.compte_libelle}
                  </td>
                  <td width="15%" style={styles.amountCell}>
                    {renderMontant(ligneF.total_debit, ligneF)}
                  </td>
                  <td width="15%" style={styles.amountCell}>
                    {renderMontant(ligneF.total_credit, ligneF)}
                  </td>
                  <td width="15%" style={styles.amountCell}>
                    {renderMontant(ligneF.total_solde_debit, ligneF)}
                  </td>
                  <td width="15%" style={styles.amountCell}>
                    {renderMontant(ligneF.total_solde_credit, ligneF)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div>
          <table style={styles.totalTable}>
            <tbody>
              <tr>
                <td colSpan="3" width="40%" style={styles.totalLabelCell}>
                  <strong>TOTAUX </strong>
                </td>
                <td width="15%" style={styles.totalAmountCell}>
                  {parseFloat(totalDebit).toLocaleString("fr-FR", {
                    style: "currency",
                    currency: "EUR",
                  })}
                </td>
                <td width="15%" style={styles.totalAmountCell}>
                  {parseFloat(totalCredit).toLocaleString("fr-FR", {
                    style: "currency",
                    currency: "EUR",
                  })}
                </td>
                <td width="15%" style={styles.totalAmountCell}>
                  {parseFloat(totalSoldeDebit).toLocaleString("fr-FR", {
                    style: "currency",
                    currency: "EUR",
                  })}
                </td>
                <td width="15%" style={styles.totalAmountCell}>
                  {parseFloat(totalSoldeCredit).toLocaleString("fr-FR", {
                    style: "currency",
                    currency: "EUR",
                  })}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}
